"use client";
import React, { useEffect, useRef } from "react";
import AppImage from "@/components/ui/AppImage";

const galerie = [
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1e1c86bec-1772450994020.png",
  alt: "RGB Gaming PC Build mit bunter Beleuchtung und sauberem Kabelmanagement",
  className: "col-span-2 row-span-2"
},
{
  src: "https://images.unsplash.com/photo-1723015297241-b1cbf891315e",
  alt: "Nahaufnahme einer High-End Grafikkarte im Gaming PC",
  className: "col-span-1 row-span-1"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_13c0ce966-1772875320985.png",
  alt: "Modernes Mainboard mit RGB Beleuchtung und Kühlsystem",
  className: "col-span-1 row-span-1"
},
{
  src: "https://images.unsplash.com/photo-1609980829355-b37d3a06f02c",
  alt: "Weißer Premium Gaming PC Setup mit Monitor und Peripherie",
  className: "col-span-1 row-span-1"
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_109bbc5ef-1772997501661.png",
  alt: "Sauberes Kabelmanagement im PC-Gehäuse",
  className: "col-span-1 row-span-1"
},
{
  src: "https://images.unsplash.com/photo-1667984461037-0658c5c776d1",
  alt: "AIO-Kühlung mit RGB-Lüftern in einem schwarzen PC-Gehäuse",
  className: "col-span-1 row-span-1"
},
{
  src: "https://images.unsplash.com/photo-1735106040751-6590050cecfe",
  alt: "Schwarzer High-End Gaming PC mit RGB-Beleuchtung",
  className: "col-span-1 row-span-1"
}];


export default function GalerieSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("revealed");
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );
    sectionRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="galerie" ref={sectionRef} className="relative py-28 lg:py-36 px-6 lg:px-12 bg-[#0A0A14] overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 reveal-hidden">
          <div className="section-label mb-4">Galerie</div>
          <h2 className="font-display font-extrabold text-[clamp(2rem,4vw,3.2rem)] text-white leading-tight">
            Sauber. Schön.{" "}
            <span className="gradient-text">Professionell.</span>
          </h2>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4 auto-rows-[200px]">
          {galerie?.map((img, i) =>
          <div
            key={i}
            className={`gallery-item reveal-hidden ${img?.className}`}
            style={{ transitionDelay: `${i * 60}ms` }}>
            
              <AppImage
              src={img?.src}
              alt={img?.alt}
              fill
              className="object-cover"
              sizes="(max-width: 768px) 50vw, 25vw" />
            
            </div>
          )}
        </div>
      </div>
    </section>);

}